import {ConfEnv} from "../../config/config";
import privateRequest from "../../Infra/http/private.request";

const putMarkAsReadNotification = id => {
  return privateRequest.put(`${ConfEnv.API_URL.URL_NOTIFICATION}/${id}/read`);
};

export {putMarkAsReadNotification};
